import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type PaperPlaceCardIconProps = CreateIconComponentProps;
export const PaperPlaceCardIcon: React.FC<PaperPlaceCardIconProps> = ({
  title = 'PaperPlaceCard',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <rect
      width="16"
      height="12"
      x="4"
      y="2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      rx=".817"
    />
    <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M9.333 11h5.647" />
    <path
      fill="currentColor"
      d="M14.583 7.107a.65.65 0 1 0-.914-.924l.914.924ZM12.252 8.5l-.457.462a.65.65 0 0 0 .914 0l-.457-.462Zm-1.417-2.318a.65.65 0 1 0-.914.924l.914-.924Zm-.91.928a.65.65 0 1 0 .906-.932l-.906.932Zm2.327-2.107-.522.388a.65.65 0 0 0 1.042.003l-.52-.39Zm1.419 1.179a.65.65 0 1 0 .91.927l-.91-.927Zm-.002 0-1.874 1.856.914.924 1.874-1.856-.914-.924Zm-.96 1.856-1.874-1.856-.914.924 1.874 1.856.914-.924Zm-1.878-1.86a.6.6 0 0 1-.154-.608l-1.241-.386a1.9 1.9 0 0 0 .489 1.926l.906-.932Zm-.154-.608a.6.6 0 0 1 .472-.412l-.219-1.282a1.9 1.9 0 0 0-1.494 1.308l1.241.386Zm.472-.412a.6.6 0 0 1 .581.233l1.044-.776a1.9 1.9 0 0 0-1.844-.739l.219 1.282Zm1.623.236a.6.6 0 0 1 .58-.23l.222-1.282a1.9 1.9 0 0 0-1.841.73l1.039.782Zm.58-.23a.6.6 0 0 1 .47.411l1.242-.387a1.9 1.9 0 0 0-1.49-1.306l-.221 1.281Zm.47.411a.6.6 0 0 1-.151.607l.91.927a1.9 1.9 0 0 0 .483-1.921l-1.241.387Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 22.5h4M12 22v-8"
    />
  </CreateIconComponent>
);
